import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { gql } from 'apollo-angular';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UploadImagesService } from 'src/app/_services/uploadImages.services';
import { Popupmodal } from 'src/app/_helpers/popupmodal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { HttpClient } from '@angular/common/http';
import { LightGallery } from 'lightgallery/lightgallery';
import Util from 'src/app/_helpers/util';
import { SubscriptionCartService } from 'src/app/_services/subscription-cart.service';

const VIEW_BILLING_CONFIRM_DETAIL = gql`
  query viewBillingConfirmDetail($input: String!) {
    viewBillingConfirmDetail(input: $input) {
      billingCountry
      billingProvince
      billingCity
      billingAddress
      billingPostalCode
      billingPhone
      billingEmail
      billingTaxId
      billingTax
      billingItem {
        offeringLabel
        price
        offeredQty
        purchasedQty
        expiredInDays
        subscriptionFeatures
      }
    }
  }
`;

const CONFIRM_OFFER = gql`
mutation confirmOffer($paymentOption:PaymentOption!,$proformaInvoiceId:String!){
    confirmOffer(input: {
        paymentOption: $paymentOption
        proformaInvoiceId: $proformaInvoiceId
    }) 
}
`;

const VIEW_INVOICE = gql`
  query viewInvoice($input: String!) {
    viewInvoice(input: $input) {
      invoiceNo
      invoiceDate
    }
  }
`;

const VIEW_PROFORMA_INVOICE_DETAIL = gql`
  query viewProformaInvoiceDetail($input: String!) {
    viewProformaInvoiceDetail(input: $input) {
      proformaInvoiceNo
      proformaInvoiceDate
      proformaInvoiceExpiredDate
      paymentMethod
      proformaInvoiceStatus
      paymentImageUrl {
        imageUrl
        paymentDate
        value
      }      
    }
  }
`;

const GENERATE_PRESIGNED_URL = gql`
    mutation generatePreSignedUrlFhProductReceipt($fileName: String!, $billingProformaInvoiceId: ID!) {
        generatePreSignedUrlFhProductReceipt(input: {
            fileName: $fileName
            billingProformaInvoiceId: $billingProformaInvoiceId
        })
    }
`;



const UPLOAD_IMAGE_RECEIPT = gql`
mutation uploadImageReceipt($fileName: String!, $billingProformaInvoiceId: ID!, $paymentValue: Float!) {
    uploadImageReceipt(input: {
        fileName: $fileName
        billingProformaInvoiceId: $billingProformaInvoiceId
        paymentValue: $paymentValue
    })
}

`;

interface BillingItem {
  offeringLabel: string;
  price: number;
  offeredQty: number;
  purchasedQty: number;
  expiredInDays: number;
  subscriptionFeatures: string[];
}

interface BillingDetail {
  billingCountry: string;
  billingProvince: string;
  billingCity: string;
  billingAddress: string;
  billingPostalCode: string;
  billingPhone: string;
  billingEmail: string;
  billingTaxId: string;
  billingTax: number;
  billingItem: BillingItem[];
}

interface Invoice {
  invoiceNo: string;
  invoiceDate: string;
}

interface PaymentImage {
  imageUrl: string;
  paymentDate: string;
  value: number;
}

interface ProformaInvoiceDetail {
  proformaInvoiceNo: string;
  proformaInvoiceDate: string;
  proformaInvoiceExpiredDate: string;
  paymentMethod: string;
  proformaInvoiceStatus: string;
  paymentImageUrl?: PaymentImage[];
}


@Component({
  selector: 'app-subscription-list-detail',
  templateUrl: './subscription-list-detail.component.html',
  styleUrls: ['./subscription-list-detail.component.scss']
})
export class SubscriptionListDetailComponent implements OnInit, OnDestroy {
  offerId: string = '';
  billingDetail: BillingDetail | null = null;
  invoice: Invoice | null = null;
  proformaInvoiceDetail: ProformaInvoiceDetail | null = null;
  loading: boolean = false;
  error: string | null = null;
  private destroy$ = new Subject<void>();
  currentLang: any;
  loadingSubmit: boolean = false;
  uploadingFile: boolean = false;
  uploadError: string | null = null;
  selectedFile: File | null = null;

  getStatus: string = '';
  getType: string = '';
  
  // File upload constants
  private readonly MAX_FILE_SIZE = 8 * 1024 * 1024; // 8MB in bytes
  private readonly ALLOWED_IMAGE_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

  companyName: string = '';
  companyId: string = '';

  lightboxImg:any = [];
  private lightGallery!: LightGallery;
  private paymentLightGallery!: LightGallery;
  private needRefresh = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apollo: Apollo,
    public translate: TranslateService,
    private popupmodal : Popupmodal,
    private modalService: NgbModal,
    private http: HttpClient,
    private uploadImagesService: UploadImagesService,
    private cartService: SubscriptionCartService,
  ) {}

  ngOnInit(): void {
    this.cartService.clearCart();
    this.loadData();

    this.companyName = localStorage.getItem('COMPANYSELECTNAME') || '';
    this.companyId = localStorage.getItem('COMPANYSELECTID') || '';
  }

  loadData(){
    this.currentLang = localStorage.getItem('language') || 'id';
    this.route.params.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      this.offerId = params['OfferId'];
      if (this.offerId) {
        this.loadBillingDetail();
        this.loadInvoiceDetail();
        this.loadProformaInvoiceDetail();
      }
    });

  this.route.queryParams.subscribe(params => {
    const type = params['type'];

    if (type === 'preview') {
      this.getStatus = 'preview';
    }

    if (type === 'download') {
      this.getStatus = 'download';
    }
    this.getType = (type || '').toLowerCase();

  });

    // //get status from query params
    // this.route.queryParams.pipe(
    //   takeUntil(this.destroy$)
    // ).subscribe(params => {
    //   this.getStatus = params['status'] || '';
    // });
  }

  loadBillingDetail(): void {
    this.loading = true;
    this.error = null;

    this.apollo.query<any>({
      query: VIEW_BILLING_CONFIRM_DETAIL,
      variables: {
        input: this.offerId
      },
      fetchPolicy: 'no-cache'
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (result: any) => {
        this.billingDetail = result.data.viewBillingConfirmDetail;
        this.loading = false;
      },
      (error: any) => {
        console.error('Error loading billing detail:', error);
        this.error = 'Failed to load billing details. Please try again.';
        this.loading = false;
      }
    );
  }

  loadInvoiceDetail(): void {
    this.apollo.query<any>({
      query: VIEW_INVOICE,
      variables: {
        input: this.offerId
      },
      fetchPolicy: 'no-cache'
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (result: any) => {
        this.invoice = result.data.viewInvoice;
      },
      (error: any) => {
        console.error('Error loading invoice detail:', error);
      }
    );
  }

  loadProformaInvoiceDetail(): void {
    this.apollo.query<any>({
      query: VIEW_PROFORMA_INVOICE_DETAIL,
      variables: {
        input: this.offerId
      },
      fetchPolicy: 'no-cache'
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (result: any) => {
        this.proformaInvoiceDetail = result.data.viewProformaInvoiceDetail;
        console.log('Proforma invoice detail loaded:', this.proformaInvoiceDetail);
      },
      (error: any) => {
        console.error('Error loading proforma invoice detail:', error);
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  modalConfirmPayment(){

    let getTotal = this.getTotalPrice();
    let textTitle = "Pastikan paket dan detail pesanan Anda sudah sesuai. Konfirmasi untuk melanjutkan ke pembayaran?"
    if(getTotal <= 0){
      textTitle = "<b>Konfirmasi downgrade paket Anda?</b><br><br>Paket akan langsung aktif. Jika penggunaan fitur saat ini melebihi limit paket baru, aktivitas fitur tersebut akan dibatasi hingga periode berikutnya dimulai."
    }


    const modalRef = this.modalService.open(ModalComponent, {
      modalDialogClass: 'modal-dialog-centered div-modal-content',
      centered: true,
      size: 'md'
    })
    modalRef.componentInstance.modalconfirm = 'modal'
    modalRef.componentInstance.title = 'Konfirmasi'
    modalRef.componentInstance.subtitle =  textTitle
    modalRef.componentInstance.yesStr = 'Ya'
    modalRef.componentInstance.noStr = 'Batal'

    modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
      if (res) this.onProceedPayment()
    })


  }

  onProceedPayment(): void {
    this.loadingSubmit = true;
    this.error = null;

    this.apollo.mutate<any>({
      mutation: CONFIRM_OFFER,
      variables: {
          paymentOption: 'WIRETRANSFER',
          proformaInvoiceId: this.offerId
      }

    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (result: any) => {
        console.log('Payment confirmation successful:', result);
        this.loadingSubmit = false;
        // TODO: Handle successful payment confirmation - navigate or show success message

        location.reload();
      },
      (error: any) => {
        console.error('Error confirming offer:', error);
        this.loadingSubmit = false;

        // Get error type from GraphQL response
        const errorType = error.graphQLErrors?.[0]?.extensions?.type;
        const errorMessage = error.graphQLErrors?.[0]?.message;

        if (errorType === 'ProformaInvoiceAlreadyConfirm') {
          this.error = 'Bukti pembayaran berhasil diunggah. Mohon tunggu proses verifikasi.';
          this.popupmodal.showError(this.error, null).subscribe((res: any) => {});
        } else {
          this.error = errorMessage || 'Failed to confirm payment. Please try again.';
          this.popupmodal.showError(this.error?this.error:'Failed to confirm payment. Please try again.', null).subscribe((res: any) => {});
        }
      }
    );

  }

  goBackToSubscriptions(): void {
    this.router.navigate(['/billing-list']);
  }

  goBackToProducts(): void {
    this.router.navigate(['/subscription-products']);
  }

  getTotalPrice(): number {
    if (!this.billingDetail?.billingItem || this.billingDetail.billingItem.length === 0) {
      return 0;
    }
    return this.billingDetail.billingItem.reduce((total, item) => total + (item.price * item.purchasedQty || 0), 0);
  }

  getGrandTotal(): number {
    const subtotal = this.getTotalPrice();
    const tax = this.billingDetail?.billingTax || 0;
    const voucher = 0;

    if(subtotal + tax - voucher <=0){
      this.getStatus = 'downgrade';
    }

    return subtotal + tax - voucher;
  }

  /**
   * Switch language
   */
  switchLang(lang: any): void {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.currentLang = lang;
  }

  /**
   * Handle file selection and validation
   */
  onFileSelected(event: any): void {

    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      console.log('No file selected');
      return;
    }

    const file: File = input.files[0];

    console.log('File name:', file.name);
    console.log('File size:', file.size);
    console.log('File type:', file.type);

    // store it if needed
    //this.selectedFile = file;


    // const file: File = event.target.files[0];
    this.uploadError = null;

    if (!file) {
      return;
    }

    // Validate file size
    if (file.size > this.MAX_FILE_SIZE) {
      this.uploadError = `File size exceeds 8MB limit. Current size: ${(file.size / (1024 * 1024)).toFixed(2)}MB`;
      return;
    }

    // Validate file format
    if (!this.ALLOWED_IMAGE_FORMATS.includes(file.type)) {
      this.uploadError = 'Only image formats (JPG, PNG, GIF, WebP) are allowed.';
      return;
    }

    this.selectedFile = file;
  }

  /**
   * Upload payment receipt
   */
  onUploadPaymentReceipt(): void {
    if (!this.selectedFile) {
      this.uploadError = 'Please select a file to upload.';
      return;
    }

    if (this.uploadError) {
      return;
    }

    this.uploadingFile = true;
    this.uploadError = null;

    const formData = new FormData();
    formData.append('image', this.selectedFile);
    const fileName = this.selectedFile.name;

    // Step 1: Resize image first, then proceed with upload chain
    this.http.post('imgs/upload/resize', formData, { responseType: 'blob' }).pipe(
      takeUntil(this.destroy$),
      switchMap((blob: Blob) => {
        console.log('Image resized successfully');
        const resizedFile = new File([blob], fileName, { type: this.selectedFile!.type });
        
        // Step 2: Generate pre-signed URL
        return this.apollo.mutate<any>({
          mutation: GENERATE_PRESIGNED_URL,
          variables: {
              fileName: fileName,
              billingProformaInvoiceId: this.offerId
          }
        }).pipe(
          switchMap((result: any) => {
            console.log('Pre-signed URL generation result:', result);
            const presignedData = result.data.generatePreSignedUrlFhProductReceipt;
            console.log('Pre-signed URL generated:', presignedData);
            console.log('Uploading file to S3 with presigned URL');
            
            // Step 3: Upload file to S3 using pre-signed URL
            return this.uploadImagesService.uploadAwsS3(presignedData, resizedFile, 100);
          })
        );
      })
    ).subscribe(
      (uploadResult: any) => {
        console.log('File uploaded to S3:', uploadResult);
        // Step 4: Submit image receipt
        this.submitImageReceipt(fileName);
      },
      (error: any) => {
        console.error('Error in upload process:', error);
        this.uploadingFile = false;
        
        // Determine error type
        if (error.message && error.message.includes('Resize')) {
          this.uploadError = 'Resize image failed, please re-upload image again';
        } else if (error.graphQLErrors) {
          this.uploadError = 'Failed to generate upload URL. Please try again.';
        } else {
          this.uploadError = 'Failed to upload file to S3. Please try again.';
        }
        
        this.popupmodal.showError(this.uploadError, null).subscribe((res: any) => {})
      }
    );
  }

  /**
   * Submit image receipt
   */
  private submitImageReceipt(fileName: string): void {
    // Calculate payment value from billing details
    const paymentValue = this.getGrandTotal();

    this.apollo.mutate<any>({
      mutation: UPLOAD_IMAGE_RECEIPT,
      variables: {
          fileName: fileName,
          billingProformaInvoiceId: this.offerId,
          paymentValue: paymentValue
      }
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe(
      (result: any) => {
        console.log('Image receipt uploaded successfully:', result);
        this.uploadingFile = false;
        this.selectedFile = null;
        
        // Update status to 'review'
        // this.getStatus = 'review';

        
        this.loadData();

        // Show success message
        this.uploadError = null;
        this.popupmodal.showSuccess("Payment receipt uploaded successfully. Your submission is under review.",null).subscribe((res:any) => {})
        
        // Reload invoice detail to reflect status change
        //this.loadInvoiceDetail();
      },
      (error: any) => {
        console.error('Error uploading image receipt:', error);
        this.uploadError = 'Failed to upload payment receipt. Please try again.';
        this.popupmodal.showError(this.uploadError,null).subscribe((res:any) => {})
        this.uploadingFile = false;
      }
    );
  }

  settingsGallery = {
    counter: true,
    download:false,
  };
  itemsGallery:any = []

  onInitGallery = (detail:any): void => {
    this.lightGallery = detail.instance;
  };

  paymentGallerySettings = {
    counter: true,
    download: false,
  };

  onInitPaymentGallery = (detail: any): void => {
    this.paymentLightGallery = detail.instance;
  };

  openPaymentGallery = (event: Event, imageUrl: string): void => {
    event.preventDefault();
    if (this.paymentLightGallery && this.proformaInvoiceDetail?.paymentImageUrl) {
      const index = this.proformaInvoiceDetail.paymentImageUrl.findIndex(p => p.imageUrl === imageUrl);
      if (index !== -1) {
        this.paymentLightGallery.openGallery(index);
      }
    }
  };

  ngAfterViewChecked(): void {
    if (this.needRefresh) {
      if(this.itemsGallery.length>0){
        this.lightGallery.refresh();
        this.needRefresh = false;
      }

    }
  }
  formatDisplayId(val:any): any {
    return Util.formatDisplayId(val)
  }

}
